"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const access_1 = require("@completeanatomy/access");
const InfoBoxStateProvider_1 = require("../../providers/InfoBoxStateProvider");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const odr_1 = require("@completeanatomy/odr");
const useTabContent_1 = require("../../hooks/useTabContent");
const noop_1 = __importDefault(require("lodash/noop"));
const playButtonStyles = {
    width: 28,
    height: 28,
};
function ItemCard({ className, title, subtitle, img = '', isSelected, onClick = noop_1.default, children, disabled = false, withVideoPlaceholder = false, access = bridge_schema_1.UIAccessModifier.Regular, accessLevel = bridge_schema_1.AccessLevel.Upgraded, }, ref) {
    const [isAccessPopupOpen, setIsAccessPopupOpen] = (0, react_1.useState)(false);
    const { isMobile } = (0, device_1.usePlatform)();
    const hasAccess = (0, access_1.useAccessCheck)(access, accessLevel);
    const [{ currentTab }] = (0, InfoBoxStateProvider_1.useInfoBoxStateContext)();
    const { show } = (0, odr_1.useOfflineSnackbars)();
    const tabContent = (0, useTabContent_1.useTabContent)(currentTab);
    const crossSectionUnavailable = currentTab === bridge_schema_1.InfoBoxTabType.CrossSections && !tabContent.isAvailable;
    const handleClick = (e) => {
        if (!hasAccess) {
            setIsAccessPopupOpen(true);
            return;
        }
        if (crossSectionUnavailable) {
            show(odr_1.ODRSnackbars.OfflineCrossSectionsSnackbar);
            return;
        }
        onClick(e);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Container, { className: className, onClick: handleClick, disabled: disabled || !hasAccess || crossSectionUnavailable, ref: ref, role: "menuitem", "aria-current": isSelected, "data-e2e": 'ItemCard_Container', children: [(0, jsx_runtime_1.jsxs)(TopContainer, { "data-e2e": 'ItemCard_TopContainer', children: [(0, jsx_runtime_1.jsx)(ImageContainer, { "$isMobile": isMobile, "data-e2e": 'ItemCard_ImageContainer', children: withVideoPlaceholder ? ((0, jsx_runtime_1.jsx)(ui_1.VideoPlaceholder, { onPlay: onClick, onSelect: onClick, image: `${img}.jpg`, buttonStyle: playButtonStyles, "data-e2e": 'ItemCard_VideoPlaceholder' })) : ((0, jsx_runtime_1.jsx)(Image, { img: img, "data-e2e": 'ItemCard_Image' })) }), (0, jsx_runtime_1.jsxs)(InfoContainer, { "$selected": isSelected, "data-e2e": 'ItemCard_InfoContainer', children: [(0, jsx_runtime_1.jsx)(Title, { "$isMobile": isMobile, "$selected": isSelected, "data-e2e": 'ItemCard_Title', children: title }), subtitle && ((0, jsx_runtime_1.jsx)(Subtitle, { "$isMobile": isMobile, "$selected": isSelected, "data-e2e": 'ItemCard_Subtitle', children: subtitle }))] })] }), Boolean(isSelected) && children] }), (0, jsx_runtime_1.jsx)(access_1.AccessPopup, { isOpen: isAccessPopupOpen, onClose: () => setIsAccessPopupOpen(false), "data-e2e": 'ItemCard_AccessPopup' })] }));
}
function Image({ img }) {
    const fixedImgUrl = (0, ui_1.fixRelativeUrl)(img);
    return img ? (0, jsx_runtime_1.jsx)(Img, { src: fixedImgUrl, "data-e2e": 'Image_Img' }) : (0, jsx_runtime_1.jsx)(ui_1.Spinner, { "data-e2e": 'Image_Spinner' });
}
exports.default = (0, react_1.forwardRef)(ItemCard);
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  padding: 5px 0;

  cursor: pointer;

  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      opacity: 0.3;
    `}
`;
const TopContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
const ImageContainer = styled_components_1.default.div `
  position: relative;

  display: flex;
  ${({ $isMobile, theme }) => $isMobile
    ? (0, styled_components_1.css) `
          width: 72px;
          min-width: 72px;
          height: 72px;
          margin-right: 20px;

          background-color: ${theme.background};
        `
    : (0, styled_components_1.css) `
          width: 66px;
          min-width: 66px;
          height: 66px;
          margin-right: 11px;
        `}
`;
const Img = styled_components_1.default.img `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const InfoContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  color: ${({ $selected, theme }) => $selected ? theme.text : theme.textSecondary};
  font-weight: ${({ $selected }) => ($selected ? 'bold' : 'normal')};
`;
const Title = styled_components_1.default.div `
  font-size: ${({ $isMobile, $selected }) => $isMobile ? 16 : $selected ? 17.5 : 16.5}px;

  user-select: text;
`;
const Subtitle = styled_components_1.default.div `
  font-weight: ${({ $isMobile }) => ($isMobile ? 300 : 'inherit')};
  font-size: ${({ $isMobile, $selected }) => $isMobile ? 13.5 : $selected ? 14 : 12}px;

  user-select: text;
`;
